module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAMAAADXqc3KAAAAZlBMVEUAAAAAj80Aj80Aj80Aj80Aj80Aj80Aj80Aj80Aj80Aj80Aj80Aj80Aj80Aj80Aj80Aj80Aj80Aj80Aj80Aj80Aj80Aj80Aj80Aj80Aj80Aj80Aj80Aj80Aj80Aj80Aj80Aj80Aj811fii0AAAAIXRSTlMAqck4xBoF8d7Oo5t5Vi8Q9dO3kikjCuG5sINpW0ZAcVFUfLzmAAAAwElEQVQoz42R2RKCMAxFBVr2HURl0/P/PynQIpTB0Ty0mXua3mRy+SMc/+acyNcIoMoMsUk7G0QtLbgncpUfPkA4znm91NnRAkDEg7tZxXdQQBz9wm/A0sDei0N2DiL6U2BRSBOkV6Xb7sEDJlIR6Lqtq5g8rShco93bfD6BolFOAfvCDn8dX/9Y0y73mGn9RaISgTQGzz2dZHjuTi/57CvBb3Yzttujnly/koLY2DeUznSFKOMtZIlnPTyC9PIj3jiiDjKKIA9yAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/验证码.png
// module id = Ajl9
// module chunks = 66